import type { NewsItem } from '@/types/media';

export const news: NewsItem[] = [
  {
    id: 'news-01',
    title: '《星河彼岸》票房突破二十亿，科幻题材迎来新高峰',
    type: '电影新闻',
    summary:
      '上映两周，《星河彼岸》累计票房突破二十亿元，成为今年最受关注的国产科幻电影，也带动了观众对硬科幻题材的讨论热情。',
    content:
      '由陈墨白执导的科幻电影《星河彼岸》上映两周后累计票房正式突破二十亿元大关，连续十天稳居单日票房榜首。影片凭借恢弘的宇宙视觉与细腻的人物情感，收获了大量观众的好评。\n\n业内人士分析，影片的成功不仅在于特效的完成度，更在于它把一个关于“归途”的故事讲得足够动人。观众在走出影院后讨论最多的，是主角顾言在虫洞尽头做出的那个选择。\n\n随着口碑持续发酵，多部原本处于筹备阶段的科幻项目也加快了立项节奏。可以预见，未来一到两年，国产科幻将迎来一轮新的创作高峰。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20news%20photo%2C%20premiere%20red%20carpet%20of%20a%20science%20fiction%20film%2C%20glowing%20green%20nebula%20backdrop%20on%20giant%20screen%2C%20audience%20silhouettes%2C%20warm%20and%20green%20tones%2C%20editorial%20photography&width=1200&height=675&seq=nc-news-01&orientation=landscape',
    publishTime: '2026-10-11',
    author: '嫩草资讯',
    tags: ['票房', '科幻', '国产电影'],
  },
  {
    id: 'news-02',
    title: '悬疑剧《长夜将明》口碑爆棚，网友直呼“一口气追完”',
    type: '电视剧新闻',
    summary:
      '《长夜将明》更新至第18集，豆瓣评分稳定在9.3，紧凑的叙事与扎实的表演让它成为本月最热门的追剧选择。',
    content:
      '由张力执导的悬疑剧《长夜将明》正在热播，随着剧情推进到第18集，观众讨论热度持续攀升。该剧以一桩尘封十年的悬案为线索，采用双线叙事，节奏紧凑、信息量密集。\n\n不少观众表示，剧中每个细节都可能是伏笔，二刷三刷才看得过瘾。导演张力在采访中透露，结尾的反转在剧本阶段就反复打磨过七稿，希望做到“情理之中、意料之外”。\n\n目前该剧评分稳定在9.3分，是本月口碑最高的国产剧集之一。',
    image:
      'https://readdy.ai/api/search-image?query=Moody%20television%20drama%20still%2C%20detective%20standing%20in%20rain%20soaked%20dark%20alley%20with%20green%20street%20light%2C%20cinematic%20suspense%20atmosphere%2C%20editorial%20news%20style&width=1200&height=675&seq=nc-news-02&orientation=landscape',
    publishTime: '2026-10-10',
    author: '嫩草资讯',
    tags: ['追剧', '悬疑', '口碑'],
  },
  {
    id: 'news-03',
    title: '《时间褶皱》确认引进内地，档期定于下月上映',
    type: '电影新闻',
    summary:
      '英国科幻口碑佳作《时间褶皱》正式宣布引进，将于下月登陆内地院线，影片此前已在海外斩获多项大奖。',
    content:
      '英国导演 Eleanor Blake 执导的科幻剧情片《时间褶皱》日前确认引进内地，片方公布了首支中文预告，并宣布档期定于下月。\n\n影片讲述一位物理学家陷入时间循环、试图改变过去的烧脑故事，在海外上映后收获了极高的评价，被认为是“近五年最优雅的科幻电影之一”。\n\n对于喜爱硬科幻与时间题材的观众来说，这部作品无疑是下个月最值得走进影院的选择。',
    image:
      'https://readdy.ai/api/search-image?query=Surreal%20sci%20fi%20cinema%20scene%2C%20floating%20glowing%20clock%20fragments%20in%20dark%20space%2C%20green%20time%20particles%2C%20elegant%20abstract%20editorial%20style%2C%20dramatic%20lighting&width=1200&height=675&seq=nc-news-03&orientation=landscape',
    publishTime: '2026-10-09',
    author: '嫩草资讯',
    tags: ['引进片', '档期', '科幻'],
  },
  {
    id: 'news-04',
    title: '古装权谋剧《权谋之局》热度登顶，服化道获一致好评',
    type: '电视剧新闻',
    summary:
      '《权谋之局》更新至第30集，凭借考究的服化道与高密度的权谋博弈，稳居各大平台热度榜第一。',
    content:
      '由郑晓龙执导的古装权谋剧《权谋之局》持续霸榜，最新更新的第30集将剧情推向高潮。剧中朝堂博弈环环相扣，台词字字有深意，被观众称为“需要开倍速看字幕的剧”。\n\n除了剧情，该剧的服化道也收获一致好评。剧组为还原时代质感，仅主角的服饰就设计了上百套，从纹样到配色都经过史料考证。\n\n目前该剧稳居各大平台热度榜第一，相关话题多次登上热搜。',
    image:
      'https://readdy.ai/api/search-image?query=Grand%20ancient%20chinese%20palace%20hall%20interior%2C%20candlelit%20throne%20room%20with%20green%20bronze%20details%2C%20dramatic%20historical%20drama%20still%2C%20cinematic%20editorial%20style&width=1200&height=675&seq=nc-news-04&orientation=landscape',
    publishTime: '2026-10-08',
    author: '嫩草资讯',
    tags: ['古装', '权谋', '热度榜'],
  },
  {
    id: 'news-05',
    title: '流媒体平台加大自制剧投入，长短视频融合成新趋势',
    type: '行业动态',
    summary:
      '多家流媒体平台公布新一季自制内容计划，加码中短剧与精品长剧，长短视频的边界正变得越来越模糊。',
    content:
      '近期，多家流媒体平台陆续公布了新一季的自制内容计划，普遍加大了对中短剧和精品长剧的投入力度，行业竞争进入新阶段。\n\n有分析指出，观众的注意力正变得愈发碎片化，如何在前三分钟抓住观众，成为内容创作者必须面对的课题。同时，精品长剧依然拥有不可替代的沉浸感与讨论度。\n\n“长短结合、以短引流、以长留存”正在成为新的内容策略。对观众而言，这意味着未来将有更多元、更密集的好内容可供选择。',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20office%2C%20wall%20of%20screens%20showing%20colorful%20video%20thumbnails%2C%20green%20accent%20lighting%2C%20clean%20corporate%20editorial%20photography&width=1200&height=675&seq=nc-news-05&orientation=landscape',
    publishTime: '2026-10-07',
    author: '嫩草资讯',
    tags: ['流媒体', '行业趋势', '自制内容'],
  },
  {
    id: 'news-06',
    title: '《深海觉醒》曝终极预告，深海恐惧感拉满',
    type: '电影新闻',
    summary:
      '《深海觉醒》发布终极预告，幽暗海沟与未知生物的画面引发热议，影片被赞“把深海恐惧拍到了极致”。',
    content:
      '科幻惊悚片《深海觉醒》日前发布终极预告，短短两分钟的画面里，深潜器坠入万米海沟、幽暗中的发光生物、以及那句“它一直在看着我们”，让不少观众直呼头皮发麻。\n\n导演 Marcus Vale 表示，影片大量采用实景搭建与水下摄影，希望让观众感受到真实的压迫感，而不是单纯依赖特效。\n\n影片上映后凭借独特的深海氛围收获不俗口碑，被认为是近年来少见的“沉浸式深海惊悚片”。',
    image:
      'https://readdy.ai/api/search-image?query=Deep%20sea%20abyss%20scene%2C%20submarine%20light%20cutting%20through%20dark%20glowing%20trench%2C%20bioluminescent%20creature%20eyes%2C%20deep%20green%20and%20black%20tones%2C%20cinematic%20editorial%20style&width=1200&height=675&seq=nc-news-06&orientation=landscape',
    publishTime: '2026-10-06',
    author: '嫩草资讯',
    tags: ['预告片', '惊悚', '深海'],
  },
  {
    id: 'news-07',
    title: '《都市浮生记》更新过半，现实主义题材再受关注',
    type: '电视剧新闻',
    summary:
      '《都市浮生记》更新至第24集，四个打工人的十年浮沉引发广泛共鸣，现实主义题材再次成为讨论焦点。',
    content:
      '都市剧《都市浮生记》更新过半，剧中四个大学同窗在大城市打拼十年的故事触动了许多观众。“看到的不是剧，是自己的十年”成为评论区的高频留言。\n\n编剧周晓透露，剧中不少情节取材于身边朋友的真实经历，希望通过小人物的浮沉，记录一个时代的变化。\n\n随着现实主义题材持续升温，如何在真实与戏剧性之间取得平衡，成为创作者们共同思考的话题。',
    image:
      'https://readdy.ai/api/search-image?query=Urban%20city%20rooftop%20at%20dusk%2C%20young%20people%20looking%20at%20glowing%20skyscrapers%2C%20warm%20green%20and%20amber%20city%20lights%2C%20cinematic%20editorial%20photography&width=1200&height=675&seq=nc-news-07&orientation=landscape',
    publishTime: '2026-10-05',
    author: '嫩草资讯',
    tags: ['都市剧', '现实主义', '共鸣'],
  },
  {
    id: 'news-08',
    title: 'AI 技术走进影视制作，虚拟拍摄降本增效',
    type: '行业动态',
    summary:
      '虚拟拍摄与 AI 辅助制作技术加速落地，正在改变影视行业的生产方式，同时引发关于创作边界的讨论。',
    content:
      '近年来，虚拟拍摄、实时渲染与 AI 辅助制作等技术加速进入影视行业，从概念设计到后期合成，越来越多的环节开始借助新工具提效。\n\n业内人士表示，新技术的价值在于把创作者从繁琐的重复劳动中解放出来，让预算和时间更多投入到剧本与表演上。\n\n与此同时，关于“技术是否会取代创作”的讨论也不绝于耳。多数从业者的共识是：工具可以替代流程，但替代不了打动人心的故事。',
    image:
      'https://readdy.ai/api/search-image?query=Virtual%20film%20production%20studio%2C%20green%20screen%20volume%20with%20holographic%20preview%2C%20camera%20rig%20and%20technicians%2C%20green%20and%20amber%20accent%20lighting%2C%20editorial%20photography&width=1200&height=675&seq=nc-news-08&orientation=landscape',
    publishTime: '2026-10-04',
    author: '嫩草资讯',
    tags: ['AI', '虚拟拍摄', '技术'],
  },
  {
    id: 'news-09',
    title: '《逆流而上》获多个影展提名，平凡故事打动评委',
    type: '电影新闻',
    summary:
      '现实主义电影《逆流而上》接连获得多个影展提名，评委会称其“用最朴素的方式讲出了最有力量的故事”。',
    content:
      '电影《逆流而上》近期接连入围多个影展，并斩获表演类与编剧类提名。影片讲述一对父女在困境中相互扶持、逆流而上的故事。\n\n有评委评价，影片没有刻意煽情，而是把力量藏在细节里，一顿饭、一条船、一次沉默，都足以让人眼眶发热。\n\n导演李安然表示，故事的灵感来自新闻里的一则短讯，“普通人的坚持，本身就值得被记录”。',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20river%20at%20sunrise%2C%20small%20boat%20rowing%20upstream%2C%20two%20figures%20silhouette%2C%20hopeful%20green%20and%20golden%20light%2C%20cinematic%20editorial%20photography&width=1200&height=675&seq=nc-news-09&orientation=landscape',
    publishTime: '2026-10-03',
    author: '嫩草资讯',
    tags: ['影展', '现实主义', '提名'],
  },
  {
    id: 'news-10',
    title: '悬疑题材持续升温，多部新剧进入筹备阶段',
    type: '行业动态',
    summary:
      '从《长夜将明》到《沉默的证词》，悬疑题材热度居高不下，多部新项目已悄然进入筹备期。',
    content:
      '近两年，悬疑题材成为剧集市场最稳定的“热门赛道”。从口碑爆棚的《长夜将明》，到完结后仍被反复讨论的《沉默的证词》，观众对高质量悬疑的胃口越来越大。\n\n据不完全统计，目前已有十余部悬疑新剧进入筹备阶段，题材从刑侦、法医延伸到职场、家庭等更多细分领域。\n\n不过，从业者也提醒，悬疑剧的核心永远是逻辑与人物，“为了反转而反转”只会消耗观众的耐心。',
    image:
      'https://readdy.ai/api/search-image?query=Dark%20empty%20courtroom%20with%20single%20hanging%20light%2C%20documents%20on%20a%20desk%2C%20moody%20green%20and%20black%20tones%2C%20cinematic%20editorial%20photography&width=1200&height=675&seq=nc-news-10&orientation=landscape',
    publishTime: '2026-10-02',
    author: '嫩草资讯',
    tags: ['悬疑', '剧集市场', '趋势'],
  },
  {
    id: 'news-11',
    title: '《钢铁纪元》幕后特辑公开，机甲设计耗时两年',
    type: '电影新闻',
    summary:
      '《钢铁纪元》公开幕后制作特辑，揭秘片中巨型机甲从概念到实拍的全过程，设计团队耗时整整两年。',
    content:
      '科幻动作大片《钢铁纪元》近日公开幕后特辑。特辑中，设计团队展示了主角机甲从草图、三维建模到实体道具的完整过程，仅核心机体就修改了数十个版本。\n\n为了拍出真实的重量感，剧组搭建了可动的大型机械结构，让演员在驾驶舱内的表演更加可信。\n\n制片人表示：“我们希望观众相信，那台钢铁巨人真的存在于这个世界上。”',
    image:
      'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20giant%20mecha%20movie%2C%20engineers%20assembling%20a%20huge%20robot%20prop%20in%20a%20workshop%2C%20green%20glowing%20core%2C%20warm%20industrial%20light%2C%20editorial%20photography&width=1200&height=675&seq=nc-news-11&orientation=landscape',
    publishTime: '2026-10-01',
    author: '嫩草资讯',
    tags: ['幕后', '机甲', '制作特辑'],
  },
  {
    id: 'news-12',
    title: '国庆档余温未散，十月影市看点前瞻',
    type: '行业动态',
    summary:
      '国庆档落幕后，十月影市依然热闹，多部类型各异的影片陆续定档，观众的选择更加丰富。',
    content:
      '随着国庆档落幕，十月影市并未冷清下来。科幻、悬疑、爱情、家庭等不同类型的影片陆续定档，为观众提供了更丰富的选择。\n\n业内预测，随着多部口碑作品的口口相传，十月整体票房有望保持平稳增长。\n\n对于影迷来说，这是一个“进影院总能找到想看的那一部”的月份。嫩草影院也将持续为大家带来最新的影视资讯与资源更新。',
    image:
      'https://readdy.ai/api/search-image?query=Cinema%20hall%20with%20rows%20of%20red%20seats%20and%20glowing%20green%20screen%2C%20popcorn%20and%20movie%20posters%20in%20lobby%2C%20warm%20cinematic%20editorial%20photography&width=1200&height=675&seq=nc-news-12&orientation=landscape',
    publishTime: '2026-09-30',
    author: '嫩草资讯',
    tags: ['档期', '前瞻', '影市'],
  },
];